/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Component, ChangeDetectionStrategy } from '@angular/core'

@Component({
  selector: 'myprofile-signup-ui-layout-prospect',
  templateUrl: './layout-prospect.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LayoutProspectComponent {}
